module.exports = __webpack_public_path__ + "static/media/footer-work-time.f7f2cb67.svg";